/**
 * Miz FAQ accordions: grid open/close animation (matches product-accordion.js behavior).
 */
(function () {
  const DURATION = 400;
  const initialized = new WeakSet();

  function closeWithAnimation(details, onDone) {
    const content = details.querySelector('.accordion__content');
    if (!content) {
      details.removeAttribute('open');
      onDone?.();
      return;
    }
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      details.removeAttribute('open');
      onDone?.();
      return;
    }
    details.classList.add('accordion--closing');
    const done = () => {
      details.removeAttribute('open');
      details.classList.remove('accordion--closing');
      onDone?.();
    };
    content.addEventListener('transitionend', function handler(ev) {
      if (ev.target !== content || ev.propertyName !== 'grid-template-rows') return;
      content.removeEventListener('transitionend', handler);
      done();
    });
    setTimeout(done, DURATION + 50);
  }

  function bindDetails(details) {
    if (initialized.has(details)) return;
    const summary = details.querySelector('summary');
    if (!summary) return;
    initialized.add(details);

    summary.addEventListener('click', (e) => {
      if (!details.closest('.miz-faq')) return;
      const isOpen = details.hasAttribute('open');
      if (isOpen) {
        e.preventDefault();
        closeWithAnimation(details);
      } else {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reducedMotion) {
          e.preventDefault();
          details.setAttribute('open', '');
          details.classList.add('accordion--opening-start');
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              details.classList.remove('accordion--opening-start');
            });
          });
        }
      }
    });
  }

  function initInRoot(root) {
    if (!root) return;
    root.querySelectorAll('.miz-faq details').forEach(bindDetails);
  }

  function initAll() {
    document.querySelectorAll('.miz-faq details').forEach(bindDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initInRoot(event.target);
  });
})();
